import React, { useState, useEffect, ChangeEvent, FormEvent } from "react";
import Button from "../../../components/Form/Button";
import Loading from "../../../components/Loading";
import { SimpleResponse } from "../../../services/api/Request";
import { SetModal } from "../../../components/Modal";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "./periods.css";
import WeekPeriod, { IWeekPeriod } from "../../../services/api/WeekPeriod";

const Periods: React.FC = () => {
  const [loading, isLoading] = useState<Boolean>(true);
  const [response, setResponse] = useState<SimpleResponse>();
  const dateCalendarInit = new Date(2021,7,1);
  const dateCalendarEnd = new Date(2021,7,31);

  const [dateRangeW1, setDateRangeW1] = useState<Date[]|null[]>([null, null]);
  const [dateRangeW2, setDateRangeW2] = useState<Date[]|null[]>([null, null]);
  const [dateRangeW3, setDateRangeW3] = useState<Date[]|null[]>([null, null]);
  const [dateRangeW4, setDateRangeW4] = useState<Date[]|null[]>([null, null]);
  const [startDateW1, endDateW1] = dateRangeW1;
  const [startDateW2, endDateW2] = dateRangeW2;
  const [startDateW3, endDateW3] = dateRangeW3;
  const [startDateW4, endDateW4] = dateRangeW4;
  const [dateRangeS, setDateRangeS] = useState<Date[]|null[]>([null, null]);
  const [startDateS, endDateS] = dateRangeS;

  async function handleFormSubmit(event: FormEvent) {
      event.preventDefault();

         let data: IWeekPeriod = {
          startDateW1: startDateW1!.getDate(),
          startDateW2: startDateW2!.getDate(),
          startDateW3: startDateW3!.getDate(),
          startDateW4: startDateW4!.getDate(),
          endDateW1: endDateW1!.getDate(),
          endDateW2: endDateW2!.getDate(), 
          endDateW3: endDateW3!.getDate(), 
          endDateW4: endDateW4!.getDate()
        };

        let dataS: IWeekPeriod = {
          startDateW1: startDateS!.getDate(),
          startDateW2: 0,
          startDateW3: 0,
          startDateW4: 0,
          endDateW1: endDateS!.getDate(),
          endDateW2: 0, 
          endDateW3: 0, 
          endDateW4: 0
        };
    
        const response: SimpleResponse = await WeekPeriod.UpdateForecast(data);
        const responseS: SimpleResponse = await WeekPeriod.UpdateSales(dataS);
        setResponse(response);
   
  }

  useEffect(() => {
    isLoading(true);
    
    Promise.all([WeekPeriod.GetForecast(), WeekPeriod.GetSales()])
      .then((value) => {
        setDateRangeW1([new Date(2021,7,value[0].startDateW1), new Date(2021,7,value[0].endDateW1)]);
        setDateRangeW2([new Date(2021,7,value[0].startDateW2), new Date(2021,7,value[0].endDateW2)]);
        setDateRangeW3([new Date(2021,7,value[0].startDateW3), new Date(2021,7,value[0].endDateW3)]);
        setDateRangeW4([new Date(2021,7,value[0].startDateW4), new Date(2021,7,value[0].endDateW4)]);

        setDateRangeS([new Date(2021,7,value[1].startDateW1), new Date(2021,7,value[1].endDateW1)]);

        isLoading(false);
      })
      .catch(console.log);
  }, []);

  return (
    <React.Fragment>
      {loading ? (
        <Loading />
      ) : (
        <React.Fragment>
            {response ? SetModal.FromResponse(response, () => {
                setResponse(undefined);
            }) : null}
            <section className="content__block">
            <form className="form" onSubmit={handleFormSubmit}>
            <div className="content__header">
              <h2 className="content__title">Periods</h2>

              <Button
                className="button button--blue button--icon button--save"
                title="Save"
              />
            </div>
              <div className="calendar-container">
                <DatePicker
                  inline
                  selectsRange={true}
                  startDate={startDateW1}
                  endDate={endDateW1}
                  minDate={dateCalendarInit}
                  maxDate={dateCalendarEnd}
                  onChange={(update:any) => { setDateRangeW1(update); }}
                  calendarClassName="hideWeekName"
                  renderCustomHeader={() => (
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      Week 1
                    </div>
                  )}
                />
                <DatePicker
                  inline
                  selectsRange={true}
                  startDate={startDateW2}
                  endDate={endDateW2}
                  minDate={dateCalendarInit}
                  maxDate={dateCalendarEnd}
                  onChange={(update:any) => {setDateRangeW2(update); }}
                  calendarClassName="hideWeekName"
                  renderCustomHeader={() => (
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      Week 2
                    </div>
                  )}
                />
                <DatePicker
                  inline
                  selectsRange={true}
                  startDate={startDateW3}
                  endDate={endDateW3}
                  minDate={dateCalendarInit}
                  maxDate={dateCalendarEnd}
                  onChange={(update:any) => { setDateRangeW3(update); }}
                  calendarClassName="hideWeekName"
                  renderCustomHeader={() => (
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      Week 3
                    </div>
                  )}
                />
                <DatePicker
                  inline
                  selectsRange={true}
                  startDate={startDateW4}
                  endDate={endDateW4}
                  minDate={dateCalendarInit}
                  maxDate={dateCalendarEnd}
                  onChange={(update:any) => { setDateRangeW4(update); }}
                  calendarClassName="hideWeekName"
                  renderCustomHeader={() => (
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      Week 4
                    </div>
                  )}
                />
              </div>
              <div className="calendar-container" style={{marginTop:"20px"}}>
                <DatePicker
                  inline
                  selectsRange={true}
                  startDate={startDateS}
                  endDate={endDateS}
                  minDate={dateCalendarInit}
                  maxDate={dateCalendarEnd}
                  onChange={(update:any) => { setDateRangeS(update); }}
                  calendarClassName="hideWeekName"
                  renderCustomHeader={() => (
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      Sales Input
                    </div>
                  )}
                />
              </div>
            
            </form>
          </section>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Periods;
